import { render, staticRenderFns } from "./DecisionStateTag.vue?vue&type=template&id=7b1c8406&"
import script from "./DecisionStateTag.vue?vue&type=script&lang=ts&"
export * from "./DecisionStateTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports